import { UserRole } from "@/types/enums";

import { User } from "@/types";

export function formatToRupee(amount: number) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(amount);
  }

export function formatDuration(minutes: number) {
    const hours = Math.floor(minutes / 60); // Get the number of hours
    const remainingMinutes = minutes % 60; // Get the remaining minutes

    return `${hours}h ${remainingMinutes}m`;
  }

  export const handleScrollUp = (scrollPosition: number) => {
    if (window.scrollY < scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  };

export const updateDateLocaleString = (data: string,count:number ,type:"add" | "delete") => {
    const newDate = new Date(data);
    if(type === "add"){
        newDate.setDate(newDate.getDate() + count);
    }else{
        newDate.setDate(newDate.getDate() - count);
    }
    return newDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  export const toCapitalize = (str: string) => {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  export const toCapitalizeString = (str: string) => {
    return str.split(' ').map(word => toCapitalize(word)).join(' ');
  }

  export const subStringWithEllipsis = (str: string, maxLength: number) => {
    return str.length > maxLength ? str.substring(0, maxLength) + '...' : str;
  }
 
  export const convertDateToFormat = (date: string) => {
    const newDate = new Date(date);
    return newDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  export const formatDateAndTime = (dateTimeString: string) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const formattedDate = `${day} ${month}`;
    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;
    return { formattedDate, formattedTime };
  };

  export const isSuperAdmin = (user: User) => {
    return ['SUPER_ADMIN'].includes(user?.role_type as UserRole);
  }

  export const convertToTFBookingId = (bookingId: string) => {
    return bookingId.replace("TJ", "TF");
  }

  export const convertToTJBookingId = (bookingId: string) => {
    return bookingId.replace("TF", "TJ");
  }
